<template>
    <div>
        <section class="agency-details">
            <div class="agency">
                <div class="text">
                    <h1 class="name">{{ agency.name }}</h1>
                    <p class="address" v-html="withLineBreaks(agency.address)"></p>
                    <p><span v-html="formatNumber(agency.phone)"></span></p>
                    <p>{{ agency.fax }}</p>
                    <p><a :href="agency.url" target="_blank">{{ agency.url }}</a></p>
                </div>
                <div id="map" class="map"></div>
            </div>
            <div class="members">
                <div class="wrapper" v-for="(member, index) in agency.members" :key="index">
                <div class="member">
                    <h3 class="name"><strong>{{ member.full_name }}</strong></h3>
                    <p class="title" v-if="member.title">{{ member.title }}</p>
                    <p v-if="member.phone">Phone: <span v-html="formatNumber(member.phone)"></span></p>
                    <p v-if="member.fax">Fax: <span v-html="formatNumber(member.fax)"></span></p>
                    <p v-if="member.email">Email: <a :href="`mailto:${member.email}`">{{ member.email }}</a></p>
                </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {Loader} from '@googlemaps/js-api-loader';

export default {
    props: {
        agency: {type: Object, required: true},
        backUrl: {type: String, default: ''},
    },

    data() {
        return {
            value: '',
            map: null,
            markers: [],
        };
    },

    computed: {
        backButton() {
            if (!this.backUrl) {
                return;
            }

            return {
                url: this.backUrl + (this.queryString ? `?${this.queryString}` : ''),
            };
        },
    },

    created() {
        this.$router.replace({path: this.basePath});
    },

    methods: {
        withLineBreaks(value) {
            return value.join('<br />');
        },

        formatNumber(number) {
        	return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },

        renderMap() {
            const loader = new Loader({
                apiKey: 'AIzaSyC8CQkol-lGStZowzYD9DgI_BKotW_FE3A',
                version: 'weekly',
            });

            loader.load().then(() => {
                const uluru = {lat: 38.0902, lng: -95.7129};
                this.map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 7,
                    fullscreenControl: 0,
                });

                const bounds = new google.maps.LatLngBounds();
                const marker = this.addToMap(this.agency);
                const loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                bounds.extend(loc);
                this.map.setCenter(marker.getPosition());
            });
        },

        addToMap(agency) {
            const marker = new google.maps.Marker({
                position: agency.coordinates,
                map: this.map,
                title: agency.name,
                id: agency.id,
            });

            this.markers.push(marker);

            return marker;
        },
    },

    mounted() {
        this.renderMap();
    },
};
</script>
